import {BaseGeometry} from './base-geometry';
import {GeometryType} from '../enums/geometry-type.enum';

export class Label extends BaseGeometry {
  latLng: google.maps.LatLngLiteral;
  n: number;
  text: string;
  textSize = 13;
  hasBackground = true;
  textColor = '#000000';

  constructor(id: string) {
    super(id, GeometryType.TYPE_LABEL);
  }

  clone(deep: boolean): BaseGeometry {
    return Object.assign({}, this);
  }

  update() {
  }

  toFirebaseData(deep?: boolean): any {
  }

  load(data: any) {
  }

}
